import { Injectable } from '@angular/core';
import { DirectiveDto } from '../model/directiveDto';
import { ApiClientService } from './util/api.client.service';

@Injectable()
export class StaffService {

  constructor(private http: ApiClientService) { }

  getDirectives(schoolShiftId?: number) {
    let params: any = {};

    if (schoolShiftId) {
      params.schoolShiftId = schoolShiftId;
    }

    return this.http.apiGet<DirectiveDto[]>('/directives', { secure: true, params: params });
  }

}



// WEBPACK FOOTER //
// D:/Projects/GitHub/education-ee-web/src/app/services/staff.service.ts